export default __webpack_public_path__ + "static/media/polaroid_pin.09bc82a1.svg";